const RouteChangeType = {
    ADD: Symbol('RouteChangeType.ADD'),
    LOST: Symbol('RouteChangeType.LOST'),
};

export default RouteChangeType;



//////////////////
// WEBPACK FOOTER
// /Users/Jovan/TitanNanoDE/node_modules/@af-modules/router/lib/RouteChangeType.js
// module id = 20
// module chunks = 0